import React, {useState, useEffect} from "react";

import LoginContent from "../content/LoginContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";
import { Helmet } from "react-helmet-async";
import LoadingBar from 'react-top-loading-bar';

function Login() {
    const [progress, setProgress] = useState(0);
    
    useEffect(()=>{
        setProgress(100);
    },[])
    return(
        <>
        <Helmet>
            <title>Login | Suvivah - Ideal Matrimonial Platform</title>

            <meta
                name="description"
                content="Login to your Suvivah account to manage your matrimonial profile, search suitable matches, and connect with like-minded families."
            />

            <meta
                name="keywords"
                content="Suvivah Login, Matrimonial Login, Marriage Login, Bengali Matrimony"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />

            <link rel="canonical" href="https://suvivah.org/login" />

            <meta property="og:type" content="website" />
            <meta property="og:title" content="Login | Suvivah" />
            <meta property="og:description" content="Securely login to your Suvivah account." />
            <meta property="og:url" content="https://suvivah.org/login" />
            <meta property="og:image" content="https://suvivah.org/images/logo.png" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Login | Suvivah" />
            <meta name="twitter:description" content="Securely login to your Suvivah account." />
        </Helmet>

        <Navbar />
        <LoginContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default Login;